module.exports = __webpack_public_path__ + "img/doKument_logo_2.4d8d50f5.png";